import moment from "moment";
import { Button } from "@shltelemedicine/shl-ui-lib";
import SelectInput from "../SelectInput/SelectInput";
import styles from "./DateInputHeader.module.css";
const currentYear = new Date().getFullYear();
const years: number[] = [];
for (let year = currentYear - 120; year <= currentYear; year++) {
  years.push(year);
}
const months = moment.months();

type DateInputHeaderProps = {
  date: Date;
  changeYear: (year: number) => void;
  changeMonth: (month: number) => void;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
};

const DateInputHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: DateInputHeaderProps) => {
  return (
    <div className="d-flex justify-content-around px-2">
      <Button
        variant=""
        className={`p-0 ${styles.navigationBtn}`}
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
      >
        <i className="fas fa-chevron-left"></i>
      </Button>
      <div className="d-flex flex-grow-1 px-3">
        <SelectInput
          className={`${styles.yearPicker} date-picker px-1`}
          value={date.getFullYear().toString()}
          items={years.map((year) => ({
            key: year.toString(),
            value: year.toString(),
          }))}
          onChange={({ target: { value } }) => changeYear(+value)}
        />
        <div className="mx-sm"></div>
        <SelectInput
          className={`${styles.monthPicker} date-picker px-1`}
          value={months[date.getMonth()]}
          items={months.map((month) => ({
            key: month.toString(),
            value: month.toString(),
          }))}
          onChange={({ target: { value } }) =>
            changeMonth(months.indexOf(value))
          }
        />
      </div>

      <Button
        variant=""
        className={`p-0 ${styles.navigationBtn}`}
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
      >
        <i className="fas fa-chevron-right"></i>
      </Button>
    </div>
  );
};

export default DateInputHeader;
